<template>
  <div class="node-hit-rate-container">
    <iframe
      class="node-hit-rate-iframe"
      :src="iframeUrl"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  computed: {
    iframeUrl() {
      return `${webConfig.api.debugger}/${this.$route.params.id}/node-hit-rate?hideMenu=1&token=${getToken()}&t=${new Date().getTime()}`
    },
  },
}
</script>

<style lang="scss" scoped>
.node-hit-rate-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.node-hit-rate-iframe {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
